import * as angular from "angular";
import {IController} from "angular";

export class AgentsPaymentTransactionsTableRowCtrl implements IController {

  agentBalanceInfo: any;
  currencySymbol: any;

  onAddTransaction: Function;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsPaymentTransactionsTableRow', {
    bindings: {
      agentBalanceInfo: '<',
      currencySymbol: '<',
      onAddTransaction: '&'
    },
    template: require('./agents-payment-transactions-table-row.html').default,
    controller: AgentsPaymentTransactionsTableRowCtrl
  });
